export const NAV_MENU_WIDTH = "250px";
export const CREATE_APP_SIDEBAR_WIDTH = "380px";
export const SETTINGS_MENU_WIDTH = "276px";
export const COLLAPSED_NAV_MENU_WIDTH = "68px";

export const INFO_BAR_WIDTH = "58px";
export const WORKSPACE_SELECT_HEIGHT = "44px";
